<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          class="box"
          ref="deliveryRequisitionForm"
          :model="deliveryRequisition"
          label-width="80px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('deliveryRequisition.serialNo')">{{
                  deliveryRequisition.serialNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.customers')">{{
                  deliveryRequisition.customerName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('deliveryRequisition.applyName')">{{
                  deliveryRequisition.applyName
                }}</el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  deliveryRequisition.createAt
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('deliveryRequisition.handOverAt')"
                  label-width="100px"
                  >{{ deliveryRequisition.handOverAt }}</el-form-item
                >
              </el-col>
            </el-row>
          </fieldset>
          <fieldset
            v-if="deliveryRequisition.deliveryRequisitionAudit != null"
            class="mgb15"
          >
            <legend>
              {{ $t("delivery.deliverInfo") }}:
              <strong>{{
                $t(
                  "verifyTypes." +
                    deliveryRequisition.deliveryRequisitionAudit.dealType
                )
              }}</strong>
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('order.operatorName')">{{
                  deliveryRequisition.deliveryRequisitionAudit.commentName
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('order.dealAt')">{{
                  deliveryRequisition.deliveryRequisitionAudit.commentAt
                }}</el-form-item>
              </el-col>
              <el-col
                v-if="
                  deliveryRequisition.deliveryRequisitionAudit.dealType ==
                  'reject'
                "
                :span="8"
              >
                <el-form-item :label="$t('verify.comment2')">
                  <raw-html
                    :content="
                      deliveryRequisition.deliveryRequisitionAudit.comment
                    "
                    class="mt5"
                  ></raw-html>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset v-if="deliveryRequisition.remark != null" class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <raw-html :content="deliveryRequisition.remark"></raw-html>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("menu.bargains") }}</legend>
            <vxe-table
              :data="computeBargains"
              :merge-cells="mergeCells"
              id="bargainsTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              :row-class-name="calculateBgColor"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="80"
              >
                <template v-slot="{ row }">
                  <span v-if="!row.isBargain">
                    <thumbnail :images="row.images"></thumbnail>
                  </span>
                  <div v-else>
                    <span class="float-left">
                      <span class="mgr5">{{ row.serialNo }}</span>
                      <span class="font10 mgr5"
                        >{{ $t("bargain.productQty") }}:{{
                          row.productQty
                        }}</span
                      >
                      <span
                        v-if="Permit.canActions('globalSalePrice')"
                        class="font10"
                      >
                        <span class="mgr5">
                          {{ $t("bargain.amount") }}:
                          <currency :code="row.currency"></currency>
                          {{ row.amount }}
                        </span>
                        <span v-if="row.settleType == 'later'">{{
                          $t("settleTypes.later")
                        }}</span>
                        <span v-if="row.settleType == 'now'">
                          <span class="mgr5">
                            {{ $t("bargain.receive") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.payAmount }}
                          </span>
                          <span v-if="row.ignoreAmount > 0" class="mgr5">
                            {{ $t("bargain.ignore") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.ignoreAmount }}
                          </span>
                          <span v-if="row.differAmount > 0" class="red mgr5">
                            {{ $t("bargain.differ") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.differAmount }}
                          </span>
                          <span
                            v-if="row.differAmount == 0"
                            class="green mgr5"
                            >{{ $t("bargain.settled") }}</span
                          >
                          <span v-if="row.differAmount < 0" class="orange">
                            {{ $t("bargain.leave") }}:
                            <currency :code="row.currency"></currency>
                            {{ row.differAmount * -1 }}
                          </span>
                        </span>
                      </span>
                    </span>
                    <div
                      v-if="row.financeAudit != null"
                      class="font12 float-left"
                    >
                      <el-popover placement="right" width="300" trigger="click">
                        <div>
                          <div class="lineH24">
                            {{ $t("verify.commentName") }}:
                            {{ row.financeAudit.commentName }}
                          </div>
                          <div class="lineH24">
                            {{ $t("verify.commentAt") }}:
                            {{ row.financeAudit.commentAt }}
                          </div>

                          <div
                            v-if="row.financeAudit.dealType == 'reject'"
                            class="lineH24"
                          >
                            {{ $t("verify.comment") }}:
                            {{ row.financeAudit.comment }}
                          </div>
                        </div>
                        <span
                          slot="reference"
                          class="popover-reference"
                          :class="
                            row.financeAudit.dealType == 'agree'
                              ? 'green-shallow'
                              : 'red'
                          "
                          >{{ $t("action.verify") }}({{
                            $t(
                              "verifyTypesSimple." + row.financeAudit.dealType
                            )
                          }})</span
                        >
                      </el-popover>
                    </div>

                    <span class="float-right font10">
                      {{ $t("menu.customers") }}:{{ row.customerName }}
                      <!-- <span
                        v-if="
                          row.replaceCustomerId != null && row.customer != null
                        "
                        >{{ row.customer.name }}</span
                      >
                      <span v-if="row.replaceCustomerId == null">{{
                        row.customerName
                      }}</span> -->
                      <span
                        v-if="row.customer != null && row.customer.type != null"
                        >({{ $t("customerTypes." + row.customer.type) }})</span
                      >
                      {{ $t("text.owner") }}:{{ row.ownerName }}
                      {{ row.shopName }}
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="120"
              >
                <template v-slot="{ row }">
                  <small v-if="row.hurry" class="red"
                    >({{ $t("order.hurrySimple") }})</small
                  >
                  <span class="font10">
                    <s v-if="row.workflowState == 'canceled'" class="grey">{{
                      row.serialNo
                    }}</s>
                    <span v-else>{{ row.serialNo }}</span>
                  </span>
                  <div class="font10">{{ row.innerSerialNo }}</div>
                  <div>
                    <state-label
                      :state="row.workflowState"
                      :permit="Permit.canActions('orderDealView')"
                    >
                      <span v-if="Permit.canActions('orderDealView')">{{
                        $t("orderStates." + row.workflowState)
                      }}</span>
                      <span v-else>{{
                        $t("orderStatesNoPermit." + row.workflowState)
                      }}</span>
                    </state-label>
                    <span v-if="row.dealType !== null">
                      {{ $t("dealTypes." + row.dealType) }}
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="handOverAt"
                :title="$t('text.handOverAt')"
                min-width="120"
              >
                <template v-slot="{ row }">
                  {{ row.handOverAt }}
                  <div v-if="row.confirmAt != null" class="font10 green">
                    {{ $t("order.confirm") }}:{{ row.confirmAt }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.productNo }}
                  <small
                    v-if="
                      row.customerProductNo != null &&
                      row.customerProductNo != ''
                    "
                    >({{ row.customerProductNo }})</small
                  >

                  <div class="font10">
                    {{ row.categoryName }}
                    <span v-if="row.productBrand != null">/</span>
                    {{ row.productBrand }}
                  </div>
                  <div class="font10">{{ row.color }} {{ row.size }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActions('globalSalePrice')"
                field="price"
                :title="$t('order.price')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <currency :code="row.currency"></currency>
                  {{ row.price }}
                  <small
                    v-if="row.discountRate != null && row.discountRate != 0"
                    >({{ row.discountRate }}%)</small
                  >
                  <div
                    v-if="row.extraCharge != null && row.extraCharge != 0"
                    class="font10"
                  >
                    {{ $t("order.extraChargeSimple") }}:
                    <currency :code="row.currency"></currency>
                    {{ row.extraCharge }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit || "" }}
                  <div class="font10">
                    {{ $t("order.complete") }}:{{ row.dealQuantity
                    }}{{ row.unit || "" }}
                  </div>
                  <div class="font10">
                    <el-popover
                      placement="right"
                      width="600"
                      trigger="click"
                      @show="getDeliveries(row)"
                    >
                      <vxe-table
                        :data="deliveries"
                        id="deliverInfosTable"
                        row-id="id"
                        ref="deliverInfosTable"
                        class="recordsTable"
                        size="mini"
                        resizable
                        round
                        auto-resize
                        highlight-hover-row
                        :scroll-y="{ enabled: false }"
                      >
                        <vxe-table-column
                          field="deliverType"
                          :title="$t('delivery.deliveryMethode')"
                        >
                          <template v-slot="{ row }">
                            <span v-if="row.deliverType != null">{{
                              $t("deliverTypes." + row.deliverType)
                            }}</span>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="express"
                          :title="$t('delivery.express')"
                        />
                        <vxe-table-column
                          field="deliverMethodName"
                          :title="$t('delivery.channel')"
                        />
                        <vxe-table-column
                          field="tracking"
                          :title="$t('delivery.tracking')"
                        />
                        <vxe-table-column
                          field="attachment"
                          :title="$t('product.attachment')"
                        >
                          <template v-slot="{ row }">
                            <thumbnail-text
                              :srcs="row.attachment"
                              :text="'附件'"
                            />
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="deliverBy"
                          :title="$t('delivery.deliverBy')"
                        />
                        <vxe-table-column
                          field="deliverAt"
                          :title="$t('delivery.deliverAt')"
                        />
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                        }}{{ row.unit || "" }}
                      </span>
                    </el-popover>
                  </div>

                  <div
                    v-if="row.deliveryRequisitionQuantity > 0"
                    class="font10"
                  >
                    <el-popover
                      placement="right"
                      width="600"
                      trigger="click"
                      @show="getDeliveryRequisitions(row)"
                    >
                      <vxe-table
                        :data="deliveryRequisitionInfos"
                        id="deliveryRequisitionInfosTable"
                        row-id="id"
                        ref="deliveryRequisitionInfosTable"
                        class="recordsTable"
                        size="mini"
                        resizable
                        round
                        auto-resize
                        highlight-hover-row
                        :scroll-y="{ enabled: false }"
                      >
                        <vxe-table-column
                          field="serialNo"
                          :title="$t('deliveryRequisition.serialNo')"
                        />

                        <vxe-table-column
                          field="applyName"
                          :title="$t('deliveryRequisition.applyName')"
                        />
                        <vxe-table-column
                          field="quantity"
                          :title="$t('deliveryRequisition.quantity')"
                        >
                          <template v-slot="{ row }">
                            <span
                              v-if="
                                row.deliveryRequisitionItems &&
                                row.deliveryRequisitionItems.length != 0
                              "
                            >
                              {{ row.deliveryRequisitionItems[0].quantity }}
                              <raw-html-limit-number
                                :content="
                                  row.deliveryRequisitionItems[0].remark
                                "
                                :number="10"
                              />
                            </span>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="handOverAt"
                          :title="$t('deliveryRequisition.handOverAt')"
                        />
                        <vxe-table-column
                          field="remark"
                          :title="$t('text.remark')"
                        >
                          <template v-slot="{ row }">
                            <raw-html-limit-number
                              :content="row.remark"
                              :number="10"
                            />
                            <div>
                              <attribute :content="row.specJson" :number="8" />
                            </div>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="createAt"
                          :title="$t('delivery.createAt')"
                        />
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                        }}{{ row.unit || "" }}
                      </span>
                    </el-popover>
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="deliverQuantity"
                :title="$t('deliveryRequisition.quantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <span v-if="getDeliveryRequisitionItem(row) != null">
                    {{ getDeliveryRequisitionItem(row).quantity }}
                    <div>
                      <raw-html-limit-number
                        :content="getDeliveryRequisitionItem(row).remark"
                        :number="10"
                      />
                    </div>
                  </span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="createAt"
                :title="$t('text.createAt')"
                min-width="110"
              />
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="10"
                    type="richText"
                  />
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          deliveryRequisition.bargains &&
          deliveryRequisition.bargains.length != 0
        "
        type="defalut"
        size="small"
        @click="print('printDeliveryRequisitionDiv')"
        >{{ $t("action.print") }}(带售价)</el-button
      >
      <el-button
        v-if="
          deliveryRequisition.bargains &&
          deliveryRequisition.bargains.length != 0
        "
        type="defalut"
        size="small"
        @click="print('printDeliveryRequisitionDivNoPrice')"
        >{{ $t("action.print") }}(不带售价)</el-button
      >
    </div>

    <div id="printDeliveryRequisitionDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <div style="text-align: center; font-size: 18px">
          {{ Permit.currentTenant().name }}
        </div>
        <div style="text-align: center; font-size: 16px">销售发货通知</div>
        <div>
          <span style="float: left">
            {{ $t("tenant.address") }}:
            <span v-if="Permit.currentTenant().country != null">{{
              $t("countries." + Permit.currentTenant().country)
            }}</span>
            {{ Permit.currentTenant().province }}{{ Permit.currentTenant().city
            }}{{ Permit.currentTenant().address }}
          </span>
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 5px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr style="border: 1px solid black">
            <td style="border: 1px solid black; padding: 5px">客户名称</td>
            <td style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.customerName }}
            </td>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("deliveryRequisition.serialNo") }}
            </td>
            <td colspan="2" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.serialNo }}
            </td>
            <td style="border: 1px solid black; padding: 5px">单据日期</td>
            <td colspan="4" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.createAt }}
            </td>
          </tr>
          <tr style="border: 1px solid black">
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid black; padding: 5px">
              <span
                v-if="
                  deliveryRequisition.bargains &&
                  deliveryRequisition.bargains.length != 0
                "
                >{{ deliveryRequisition.bargains[0].customerPhone }}</span
              >
            </td>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.customerAddress") }}
            </td>
            <td colspan="7" style="border: 1px solid black; padding: 5px">
              <span
                v-if="
                  deliveryRequisition.bargains &&
                  deliveryRequisition.bargains.length != 0
                "
              >
                <span
                  v-if="deliveryRequisition.bargains[0].customerCountry != null"
                  >{{
                    $t(
                      "countries." +
                        deliveryRequisition.bargains[0].customerCountry
                    )
                  }}</span
                >
                {{ deliveryRequisition.bargains[0].customerProvince
                }}{{ deliveryRequisition.bargains[0].customerCity
                }}{{ deliveryRequisition.bargains[0].customerAddress }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("text.remark") }}
            </td>
            <td colspan="9" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.remark }}
            </td>
          </tr>
          <tr>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              序号
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 80px"
            >
              {{ $t("product.productNo") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("product.category") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("product.color") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 50px"
            >
              {{ $t("product.size") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("text.quantity") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("product.salesPrice") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 110px"
            >
              {{ $t("order.serialNo") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 100px"
            >
              {{ $t("text.remark") }}
            </td>
          </tr>
          <span
            v-if="
              deliveryRequisition.bargains &&
              deliveryRequisition.bargains.length != 0
            "
          >
            <span
              v-for="(bargain, bargainIndex) in deliveryRequisition.bargains"
              :key="bargainIndex"
            >
              <tr
                v-for="(order, orderIndex) in bargain.orders"
                :key="orderIndex"
              >
                <td style="border: 1px solid black; text-align: center">
                  {{ bargainIndex + orderIndex + 1 }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.productNo }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.categoryName }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.color || "" }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.size || "" }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  <span v-if="getDeliveryRequisitionItem(order) != null"
                    >{{ getDeliveryRequisitionItem(order).quantity
                    }}{{ order.unit }}</span
                  >
                </td>
                <td style="border: 1px solid black; text-align: center">
                  <currency :code="order.currency"></currency>
                  {{ order.productPrice }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.serialNo }}
                </td>
                <td style="border: 1px solid black">
                  <span v-if="getDeliveryRequisitionItem(order) != null">
                    <raw-html
                      :content="getDeliveryRequisitionItem(order).remark"
                      style="font-size: 10px"
                    ></raw-html>
                  </span>
                </td>
              </tr>
            </span>
          </span>

          <tr>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">
              <span
                v-if="
                  deliveryRequisition &&
                  deliveryRequisition.deliveryRequisitionItems &&
                  deliveryRequisition.deliveryRequisitionItems.length !== 0
                "
                >{{ computeQuantity() }}</span
              >
            </td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
          </tr>
        </table>
        <div>
          <span style="float: right; margin-right: 20px"
            >制单人:{{ deliveryRequisition.applyName }}</span
          >
        </div>
        <div>
          <div>温馨提示：</div>
          <div>
            1、我司婚纱/礼服订货周期为45-60天，如顾客有特殊要求请与礼服顾问进行沟通。
          </div>
          <div>
            2、此单一经开通，恕不接受退换货，如质量有问题，请与礼服顾问协商。
          </div>
          <div>我司婚纱/礼服感谢您的惠顾！并衷心祝福新人幸福美满</div>
        </div>
      </div>
    </div>
    <div id="printDeliveryRequisitionDivNoPrice" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <div style="text-align: center; font-size: 18px">
          {{ Permit.currentTenant().name }}
        </div>
        <div style="text-align: center; font-size: 16px">销售发货通知</div>
        <div>
          <span style="float: left">
            {{ $t("tenant.address") }}:
            <span v-if="Permit.currentTenant().country != null">{{
              $t("countries." + Permit.currentTenant().country)
            }}</span>
            {{ Permit.currentTenant().province }}{{ Permit.currentTenant().city
            }}{{ Permit.currentTenant().address }}
          </span>
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 5px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr style="border: 1px solid black">
            <td style="border: 1px solid black; padding: 5px">客户名称</td>
            <td style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.customerName }}
            </td>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("deliveryRequisition.serialNo") }}
            </td>
            <td colspan="2" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.serialNo }}
            </td>
            <td style="border: 1px solid black; padding: 5px">单据日期</td>
            <td colspan="2" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.createAt }}
            </td>
          </tr>
          <tr style="border: 1px solid black">
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.customerPhone") }}
            </td>
            <td style="border: 1px solid black; padding: 5px">
              <span
                v-if="
                  deliveryRequisition.bargains &&
                  deliveryRequisition.bargains.length != 0
                "
                >{{ deliveryRequisition.bargains[0].customerPhone }}</span
              >
            </td>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("bargain.customerAddress") }}
            </td>
            <td colspan="5" style="border: 1px solid black; padding: 5px">
              <span
                v-if="
                  deliveryRequisition.bargains &&
                  deliveryRequisition.bargains.length != 0
                "
              >
                <span
                  v-if="deliveryRequisition.bargains[0].customerCountry != null"
                  >{{
                    $t(
                      "countries." +
                        deliveryRequisition.bargains[0].customerCountry
                    )
                  }}</span
                >
                {{ deliveryRequisition.bargains[0].customerProvince
                }}{{ deliveryRequisition.bargains[0].customerCity
                }}{{ deliveryRequisition.bargains[0].customerAddress }}
              </span>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 5px">
              {{ $t("text.remark") }}
            </td>
            <td colspan="7" style="border: 1px solid black; padding: 5px">
              {{ deliveryRequisition.remark }}
            </td>
          </tr>
          <tr>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              序号
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 80px"
            >
              {{ $t("product.productNo") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("product.category") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("product.color") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 50px"
            >
              {{ $t("product.size") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 60px"
            >
              {{ $t("text.quantity") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 110px"
            >
              {{ $t("order.serialNo") }}
            </td>
            <td
              style="border: 1px solid black; text-align: center; width: 100px"
            >
              {{ $t("text.remark") }}
            </td>
          </tr>
          <span
            v-if="
              deliveryRequisition.bargains &&
              deliveryRequisition.bargains.length != 0
            "
          >
            <span
              v-for="(bargain, bargainIndex) in deliveryRequisition.bargains"
              :key="bargainIndex"
            >
              <tr
                v-for="(order, orderIndex) in bargain.orders"
                :key="orderIndex"
              >
                <td style="border: 1px solid black; text-align: center">
                  {{ bargainIndex + orderIndex + 1 }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.productNo }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.categoryName }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.color || "" }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.size || "" }}
                </td>
                <td style="border: 1px solid black; text-align: center">
                  <span v-if="getDeliveryRequisitionItem(order) != null"
                    >{{ getDeliveryRequisitionItem(order).quantity
                    }}{{ order.unit }}</span
                  >
                </td>
                <td style="border: 1px solid black; text-align: center">
                  {{ order.serialNo }}
                </td>
                <td style="border: 1px solid black">
                  <span v-if="getDeliveryRequisitionItem(order) != null">
                    <raw-html
                      :content="getDeliveryRequisitionItem(order).remark"
                      style="font-size: 10px"
                    ></raw-html>
                  </span>
                </td>
              </tr>
            </span>
          </span>

          <tr>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">
              <span
                v-if="
                  deliveryRequisition &&
                  deliveryRequisition.deliveryRequisitionItems &&
                  deliveryRequisition.deliveryRequisitionItems.length !== 0
                "
                >{{ computeQuantity() }}</span
              >
            </td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
            <td style="border: 1px solid black; text-align: center">&nbsp;</td>
          </tr>
        </table>
        <div>
          <span style="float: right; margin-right: 20px"
            >制单人:{{ deliveryRequisition.applyName }}</span
          >
        </div>
        <div>
          <div>温馨提示：</div>
          <div>
            1、我司婚纱/礼服订货周期为45-60天，如顾客有特殊要求请与礼服顾问进行沟通。
          </div>
          <div>
            2、此单一经开通，恕不接受退换货，如质量有问题，请与礼服顾问协商。
          </div>
          <div>我司婚纱/礼服感谢您的惠顾！并衷心祝福新人幸福美满</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Currency from "@/components/Currency";
import DeliveryRequisition from "@/api/deliveryRequisition.js";
import Delivery from "@/api/delivery.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    Currency,
  },
  data() {
    return {
      deliveryRequisition: { serialNo: null },
      computeBargains: [],
      mergeCells: [],
      //
      deliveries: [],
      deliveryRequisitionInfos: [],
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    print(type) {
      this.printFunction(type);
    },

    computeQuantity() {
      if (
        this.deliveryRequisition &&
        this.deliveryRequisition.deliveryRequisitionItems.length !== 0
      ) {
        let totalQuantity = 0;
        for (const d of this.deliveryRequisition.deliveryRequisitionItems) {
          totalQuantity = totalQuantity + d.quantity;
        }
        return totalQuantity;
      } else {
        return 0;
      }
    },

    loadData() {
      const self = this;
      self.loadingStart();
      DeliveryRequisition.findById(self.id).then(function (res) {
        self.loadingEnd();
        if (res.data.code === 200) {
          self.deliveryRequisition = res.data.entity;
          if (
            self.deliveryRequisition.bargains &&
            self.deliveryRequisition.bargains.length != 0
          ) {
            self.computeBargains = self.buildTableData(
              self.deliveryRequisition.bargains
            );
            self.mergeCells = self.buildMergeCells(
              self.deliveryRequisition.bargains
            );
          }
        } else {
          self.sysError();
        }
      });
    },
    //
    getDeliveryRequisitions(row) {
      const self = this;
      DeliveryRequisition.findByOrderSerialNo({
        orderSerialNo: row.serialNo,
        deliveryRequisition: "unDeal",
      }).then(function (res) {
        if (res.status === 200) {
          self.deliveryRequisitionInfos = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    getDeliveryRequisitionItem(item) {
      const self = this;
      if (self.deliveryRequisition.deliveryRequisitionItems.length !== 0) {
        const currentDeliveryRequisitionItem =
          self.deliveryRequisition.deliveryRequisitionItems.find(
            (d) => d.orderId === item.id
          );
        return currentDeliveryRequisitionItem;
      } else {
        return null;
      }
    },
    //
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          uuid: record.uuid,
          serialNo: record.serialNo,
          shopId: record.shopId,
          shopName: record.shopName,
          settleType: record.settleType,
          amount: record.amount,
          currency: record.currency,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          customerType: record.customerType,
          customerSource: record.customerSource,
          customerEmail: record.customerEmail,
          deliveryRemark: record.deliveryRemark,
          groupJson: record.groupJson,
          remark: record.remark,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          createAt: record.createAt,
          plateform: record.plateform,
          plateformBargainId: record.plateformBargainId,
          cnyAmount: record.cnyAmount,
          replaceCustomerId: record.replaceCustomerId,
          lastDealtAt: record.lastDealtAt,
          customer: record.customer,
          productAmount: record.productAmount,
          // currentMonthAmount: record.currentMonthAmount,
          plateformStoreId: record.plateformStoreId,
          financeDeliveryAt: record.financeDeliveryAt,
          deliveryAudit: record.deliveryAudit,
          financeAudit: record.financeAudit,
          payAmount: record.payAmount,
          productQty: record.productQty,
          differAmount: record.differAmount,
          ignoreAmount: record.ignoreAmount,
          orders: record.orders,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.orders.forEach((order) => {
          rs.push(order);
        });
      });
      return rs;
    },
    buildMergeCells(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        if (this.Permit.canActions("globalSalePrice")) {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 9 });
        } else {
          mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 8 });
        }
        rowIdx = rowIdx + bargains[i].orders.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain ? "light-blue-bg" : "";
    },
  },
};
</script>